
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-profiles",
      function () {
        return require("private-next-pages/company-profiles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-profiles"])
      });
    }
  